<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <div class="card">
                <div class="card-body border-bottom">
                    <div class="row">
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <vue-select
                                    v-model="table_filter.is_insecure"
                                    :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' osäkra fodringar' }))"
                                    placeholder="-- Osäkra fodringar --"
                                    :reduce="(opt) => opt.id"
                                ></vue-select>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <vue-select
                                    v-model="table_filter.is_bankrupt"
                                    :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' kundförlust/konkurs' }))"
                                    placeholder="-- Kundförlust/konkurs --"
                                    :reduce="(opt) => opt.id"
                                ></vue-select>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <vue-select
                                    v-model="table_filter.is_credit"
                                    :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' kreditfakturor' }))"
                                    placeholder="-- Kreditfakturor --"
                                    :reduce="(opt) => opt.id"
                                ></vue-select>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <vue-select
                                    v-model="table_filter.is_paid"
                                    :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' betalda' }))"
                                    placeholder="-- Betalda --"
                                    :reduce="(opt) => opt.id"
                                ></vue-select>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <vue-select
                                    v-model="table_filter.is_late"
                                    :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' förfallna' }))"
                                    placeholder="-- Föfallna --"
                                    :reduce="(opt) => opt.id"
                                ></vue-select>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 col-xl-3">
                            <div class="form-group">
                                <vue-select
                                    v-model="table_filter.reminder"
                                    :options="status_options.map((opt) => ({ id: opt.id, label: opt.label + ' påminnelser att hantera' }))"
                                    placeholder="-- Påminnelser --"
                                    :reduce="(opt) => opt.id"
                                ></vue-select>
                            </div>
                        </div>
                    </div>
                </div>
                <rednax-datatable
                    :url="'/vue/invoices'"
                    :columns="table_columns"
                    :filter="table_filter"
                    @updateFilter="table_filter=$event"
                    sort-by="ExpireDate"
                    sort-order="asc"
                    @rowclick="rowClick"
                    ref="tblcinvoices"
                    no-wrapper
                    :per-page="1000"
                    @data:loaded="getInvoiceStats"
                >
                    <template #cell_InvoiceID="{ row }">
                        <router-link :to="{ name: 'invoice.edit', params: { id: row.InvoiceID } }">{{ row.ocr }}</router-link>
                    </template>
                    <template #cell_OrderID="{ row }">
                        <router-link :to="{ name: 'cardorders.edit', params: { id: row.OrderID } }">{{ row.OrderID }}</router-link>
                    </template>
                    <template #cell_CompanyName="{ row }">
                        <router-link :to="{ name: 'customers.edit', params: { id: row.CustomerID } }">{{ row.CompanyName }}</router-link>
                    </template>
                    <template #cell_InvoiceSumFull="{ row }">
                        {{ formatNumber(row.InvoiceSumFull, 2) }} {{ (row.CurrencyShort ? row.CurrencyShort : 'SEK') }}
                    </template>
                    <template #cell_debt="{ row }">
                        {{ formatNumber((row.isPaid ? 0 : row.debt), 2) }} {{ (row.CurrencyShort ? row.CurrencyShort : 'SEK') }}
                    </template>
                    <template #cell_debt_sek="{ row }">
                        {{ formatNumber((row.isPaid ? 0 : row.debt_sek), 2) }}
                    </template>
                    <template #cell_InvoiceDate="{ row }">
                        <div>{{ row.InvoiceDate }}</div>
                        <div v-if="row.isReminded >= 1 && row.RemindDate" class="text-danger-700">P1: {{ row.RemindDate }}</div>
                        <div v-if="row.isReminded >= 2 && row.RemindDate2" class="text-danger-600">P2: {{ row.RemindDate2 }}</div>
                        <div v-if="row.RemindDate3" class="text-danger">SAMTAL: {{ row.RemindDate3 }}</div>
                        <div v-if="row.SentToKronofogden" class="text-danger">KRONOF: {{ row.KronofogdenDate }}</div>
                    </template>
                    <template #cell_reminder="{ row }">
                        <div v-if="row.debt > 0 && row.reminder === 'P1'">
                            <label class="mb-0">P1 <input type="checkbox" :name="'chk-p1-' + row.InvoiceID" :true-value="1" :false-value="0" v-model="reminder[row.InvoiceID]" style="vertical-align: middle;"></label>
                        </div>
                        <div v-else-if="row.debt > 0 && row.reminder === 'P2'">
                            <label class="mb-0">P2 <input type="checkbox" :name="'chk-p2-' + row.InvoiceID" :true-value="2" :false-value="0" v-model="reminder[row.InvoiceID]" style="vertical-align: middle;"></label>
                        </div>
                        <div v-else-if="row.debt > 0 && row.reminder">
                            <div class="badge badge-danger">!</div>
                        </div>
                    </template>
                    <template #cell_LateDays="{ row }">
                        <div v-if="row.isPaid" class="badge badge-success">Betald</div>
                        <div v-else-if="row.CustomerID === 1635" class="badge bg-blue-600 text-white">{{ row.LateDays }}</div>
                        <div v-else-if="row.debt < 0" class="badge badge-warning">{{ row.LateDays }}</div>
                        <div v-else-if="round(row.debt) !== round(row.InvoiceSumFull)" class="badge bg-purple-600 text-white">{{ row.LateDays }}</div>
                        <div v-else-if="row.LateDays < 0" class="badge bg-danger-600 text-white">{{ row.LateDays }}</div>
                        <div v-else class="badge badge-info">{{ row.LateDays }}</div>
                    </template>
                    <template #cell_Status="{ row }">
                        <div v-if="row.isPaid" class="">Betald</div>
                        <div v-else-if="row.isInsecure >= 2" class="">Kundförlust/konkurs</div>
                        <div v-else-if="row.isInsecure >= 1" class="">Osäker fodring</div>
                        <div v-else-if="row.SentToKronofogden" class="">Kronofogden</div>
                        <div v-else-if="row.LateDays < 0" class="">Förfallen</div>
                        <div v-else-if="row.isAccepted" class="">Skickad</div>
                        <div v-else class="">Ny</div>
                    </template>
                    <template #buttons>
                        <button
                            type="button"
                            class="btn btn-warning mr-3"
                            @click="createReminders"
                            :disabled="selected_invoice_ids.length <= 0"
                        >Skapa påminnelser</button>
                    </template>
                </rednax-datatable>
                <div class="card-body border-top">
                    <div v-if="busy_loading_invoice_stats">
                        <i class="icon-spinner2 spinner"></i>
                    </div>
                    <table v-else-if="invoice_stats" class="table table-bordered table-sm" style="max-width: 400px;">
                        <tbody>
                            <tr>
                                <th>Väntande</th>
                                <td class="bg-info text-right text-white">{{ formatNumber(invoice_stats.wait, 0) }} kr</td>
                            </tr>
                            <tr>
                                <th>Förfallna</th>
                                <td class="bg-danger text-right text-white">{{ formatNumber(invoice_stats.late, 0) }} kr</td>
                            </tr>
                            <tr>
                                <th>Delbetalda, rest</th>
                                <td class="bg-purple text-right text-white">{{ formatNumber(invoice_stats.subtot - invoice_stats.partially_paid, 0) }} kr</td>
                            </tr>
<!--                            <tr>-->
<!--                                <th>Delbetala</th>-->
<!--                                <td class="bg-purple text-right">{{ formatNumber(invoice_stats.subtot, 0) }} kr</td>-->
<!--                            </tr>-->
<!--                            <tr>-->
<!--                                <th>Inbetalt</th>-->
<!--                                <td class="bg-purple text-right">{{ formatNumber(0 - invoice_stats.partially_paid, 0) }} kr</td>-->
<!--                            </tr>-->
                            <tr>
                                <th>Total skuld</th>
                                <td class="bg-light text-right">
                                    {{ formatNumber(((invoice_stats.wait + invoice_stats.late + invoice_stats.subtot) - invoice_stats.partially_paid), 0) }} kr
                                </td>
                            </tr>
                            <tr>
                                <th>Ej återbetalt</th>
                                <td class="bg-warning text-white text-right">
                                    {{ formatNumber(invoice_stats.not_refunded, 0) }} kr
                                </td>
                            </tr>
                            <tr>
                                <th>Summa</th>
                                <td class="bg-light text-right">
                                    {{ formatNumber(((invoice_stats.wait + invoice_stats.late + invoice_stats.subtot) - invoice_stats.partially_paid) + invoice_stats.not_refunded, 0) }} kr
                                </td>
                            </tr>
                            <tr v-if="invoice_stats.newport_debt > 0 || invoice_stats.fully_paid > 0">
                                <th></th>
                                <th></th>
                            </tr>
                            <tr v-if="invoice_stats.fully_paid > 0">
                                <th>Fullbetalda</th>
                                <td class="bg-success text-right">{{ formatNumber(invoice_stats.fully_paid, 0) }} kr</td>
                            </tr>
                            <tr v-if="invoice_stats.newport_debt > 0">
                                <th>Newport skuld</th>
                                <td class="bg-blue-600 text-right text-white">
                                    {{ formatNumber(invoice_stats.newport_debt, 0) }} kr
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatNumber, round } from '@services/Helpers';
import VueSelect from '@components/Wrappers/VueSelect.vue';

export default {
    components: {
        VueSelect,
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            is_insecure: null,
            is_bankrupt: null,
            is_credit: null,
            is_paid: null,
            is_late: null,
            reminder: null,
        },
        invoice_stats: null,
        busy_loading_invoice_stats: false,
        reminder: {},
        status_options: [
            {
                id: null,
                label: 'Inkl. ',
            },
            {
                id: 1,
                label: 'Endast',
            },
            {
                id: 0,
                label: 'Dölj',
            },
        ],
    }),
    methods: {
        round,
        formatNumber,
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/cardseries/' + row.CardSeriesID).focus();
            } else {
                this.$router.push({
                    name: 'invoice.edit',
                    params: { id: row.InvoiceID },
                });
            }
        },
        async createReminders() {
            if (this.selected_invoice_ids.length > 0) {
                let doDelete = false;
                await this.$swal({
                    text: 'Är du säker att du vill skapa en påminnelser för ' + this.selected_invoice_ids.length + ' st fakturor?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, skapa påminnelser!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        doDelete = true;
                    }
                });
                if (doDelete) {
                    await this.$router.push({
                        name: 'invoice.preview',
                        query: {
                            invoice_ids: this.selected_invoice_ids,
                            reminder: true,
                        },
                    });
                }
            }
        },
        getInvoiceStats(data) {
            if (data.stats) {
                this.invoice_stats = data.stats;
            }
        },
    },
    computed: {
        table_columns() {
            return [
                {
                    header: 'OCR',
                    data: 'InvoiceID',
                    sortable: true,
                },
                {
                    header: 'Order',
                    data: 'OrderID',
                    sortable: true,
                },
                {
                    header: 'Kund',
                    data: 'CompanyName',
                    sortable: true,
                },
                {
                    header: 'Fakturadatum',
                    data: 'InvoiceDate',
                    sortable: true,
                },
                {
                    header: 'Förfallodatum',
                    data: 'ExpireDate',
                    sortable: true,
                },
                {
                    header: 'Fakturabelopp',
                    data: 'InvoiceSumFull',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Skuld',
                    data: 'debt',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Skuld (SEK)',
                    data: 'debt_sek',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Dagar kvar',
                    data: 'LateDays',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Påminnelse',
                    data: 'reminder',
                    sortable: false,
                    clickable: false,
                },
                {
                    header: 'Status',
                    data: 'Status',
                    sortable: true,
                },
            ];
        },
        selected_invoice_ids() {
            return Object.keys(this.reminder).filter((r) => this.reminder[r]);
        },
    },
};

</script>
